import * as React from 'react'

import { NavigationRoutesFn } from 'modules/core/lib/react-router'

const FixFlowPage = React.lazy(() => import('modules/contracts/pages/employees/FixFlowPage'))
const RequestOrUpdatePage = React.lazy(
  () => import('modules/contracts/pages/employees/RequestOrUpdatePage')
)

const RequestOrPromotePage = React.lazy(
  () => import('modules/contracts/pages/employees/RequestOrPromotePage')
)
const ApprovePromotionPage = React.lazy(
  () => import('modules/contracts/pages/ApprovePromotionPage')
)
const ContractVersionsPage = React.lazy(
  () => import('modules/contracts/pages/ContractVersionsPage')
)
const EmployeeContractPage = React.lazy(
  () => import('modules/contracts/pages/employees/EmployeeContractPage')
)
const RootFlowPage = React.lazy(() => import('modules/contracts/pages/employees/RootFlowPage'))
const RootPage = React.lazy(() => import('modules/contracts/pages/employees/RootPage'))

const employeesRoutes: NavigationRoutesFn = (navigation) => [
  {
    path: navigation.employees.id.contractVersions.path,
    children: [
      {
        element: <EmployeeContractPage />,
        children: [
          {
            index: true,
            element: <ContractVersionsPage />,
          },
          {
            path: navigation.employees.id.contractVersions.contractVersionId.path,
            element: <ContractVersionsPage />,
          },
        ],
      },
      {
        element: <RootPage />,
        children: [
          {
            element: <RootFlowPage />,
            children: [
              {
                path: navigation.employees.id.contractVersions.fix.path,
                element: <FixFlowPage />,
              },
              {
                path: navigation.employees.id.contractVersions.update.path,
                element: <RequestOrUpdatePage />,
              },
              {
                path: navigation.employees.id.contractVersions.promotion.path,
                element: <RequestOrPromotePage />,
              },
            ],
          },
        ],
      },
      {
        element: <ApprovePromotionPage />,
        path: navigation.employees.id.contractVersions.approval_request.path,
      },
    ],
  },
]

export default employeesRoutes
